export default __webpack_public_path__ + "static/media/tech-react.9e4415bf.svg";